export interface ClientInfo {
  platform?: 'ios' | 'android' | 'web';
  appVersion?: string;
  deviceModel?: string;
  osVersion?: string;
  screenSize?: string;
}

interface ClientInfoItemsProps {
  clientInfo?: ClientInfo | null;
  /** CSS class for each row. Defaults to "detail-item" */
  itemClassName?: string;
}

const PLATFORM_LABELS: Record<string, string> = {
  ios: 'iOS App',
  android: 'Android App',
  web: 'Web App',
};

/** Renders detail-item rows for client info. No wrapper — drop directly into a detail grid. */
export function ClientInfoItems({ clientInfo, itemClassName = 'detail-item' }: ClientInfoItemsProps) {
  return (
    <>
      <div className={itemClassName}>
        <label>Client</label>
        <span>{PLATFORM_LABELS[clientInfo?.platform || 'web'] || 'Web App'}</span>
      </div>
      {clientInfo?.appVersion && (
        <div className={itemClassName}>
          <label>App Version</label>
          <span>{clientInfo.appVersion}</span>
        </div>
      )}
      {clientInfo?.deviceModel && (
        <div className={itemClassName}>
          <label>Device</label>
          <span>{clientInfo.deviceModel}</span>
        </div>
      )}
      {clientInfo?.osVersion && (
        <div className={itemClassName}>
          <label>OS</label>
          <span>{clientInfo.osVersion}</span>
        </div>
      )}
      {clientInfo?.screenSize && (
        <div className={itemClassName}>
          <label>Screen</label>
          <span>{clientInfo.screenSize}</span>
        </div>
      )}
    </>
  );
}
